/**
 * The wordmark: a parcel with its hub label and an RFID tag beside the product name.
 * Rename or swap the logo in config/brand.ts.
 */
import { BRAND } from '../../config/brand';
import { cx } from '../../components/ui';

export function DrawerGlyph({ className }: { className?: string }) {
  // A parcel with its hub label (barcode lines) and a tag: one ID, two carriers.
  return (
    <svg viewBox="0 0 32 32" aria-hidden className={className}>
      <path d="M4 10.5 16 5l12 5.5v12.5L16 28.5 4 23z" fill="rgb(var(--brand))" />
      <path d="M4 10.5 16 16l12-5.5M16 16v12.5" fill="none" stroke="rgb(var(--card))" strokeWidth="1.2" strokeLinejoin="round" />
      <rect x="6.5" y="15.5" width="7" height="5.5" rx="0.8" fill="rgb(var(--card))" transform="skewY(24) translate(0 -3.2)" />
      <path d="M8 13.6v3.6M9.2 14.1v3.6M10.6 14.7v3.6M11.6 15.1v3.6" stroke="rgb(var(--ink, 20 20 20))" strokeWidth="0.6" />
      <circle cx="22" cy="20.5" r="2" fill="rgb(var(--rule))" />
    </svg>
  );
}

export function Wordmark({ compact, className }: { compact?: boolean; className?: string }) {
  if (BRAND.logoUrl) return <img src={BRAND.logoUrl} alt={BRAND.product} className={cx('h-8 w-auto', className)} />;
  return (
    <span className={cx('inline-flex items-center gap-2.5', className)}>
      <DrawerGlyph className="h-8 w-8 shrink-0" />
      {!compact && <span className="display whitespace-nowrap text-[19px] text-ink">{BRAND.product}</span>}
    </span>
  );
}
